var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgHashratePlus = function SvgHashratePlus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.902 13.797c-.302.621-.66 1.21-1.068 1.759a9 9 0 1 0 0-13.112c.408.55.767 1.138 1.068 1.76a7 7 0 1 1 0 9.594ZM23 5v3h-3v2h3v3h2v-3h3V8h-3V5h-2Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm-3.375-7.875 4.5-7.875L9 7.875h3.375l-4.5 7.875L9 10.125H5.625Z",
    fill: "currentColor"
  })));
};
export default SvgHashratePlus;